export enum GameId {
    TileClicker = "tile-clicker",
    BanterBattle = "witocracy",
    Taptionary = "word-drift",
    GrowGrowTomato = "grow-grow-tomato",
    Craftegory = "craftegory",
    AnalogyAscent = "analogy-ascent",
    // Add additional game IDs as needed.
}